export default __webpack_public_path__ + "static/media/IdealProductCostOrangeIcon.2f9874c0.png";